import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TrackedButton as Button } from '../../../components/TrackedComponents';
import { MuiTextField } from '../Accident/MuiFormControls';
import { STATUS } from './DriverModal';

interface NewCoachingModalProps {
    defaultDriver?: string;
    onSave: CallableFunction;
    children: React.ReactNode;
}

const NewCoachingModal: React.FC<NewCoachingModalProps> = (props: NewCoachingModalProps) => {
    const [isGroupedSession, setIsGroupedSession] = useState<boolean>(false);
    const [comment, setComment] = useState<string>('');
    const { t } = useTranslation();
    const hasNoDriver = props.defaultDriver === undefined;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, p: 2 }}>
            <Typography textAlign="center" variant="h6">
                {t('content.safety.save_event')}
            </Typography>
            <MuiTextField
                id="driver-name"
                name="driver_name"
                label={t('table.headers.driver_name')}
                value={isGroupedSession ? '' : props.defaultDriver || ''}
                disabled
            />
            <MuiTextField
                id="comment"
                name="comment"
                label={t('content.events.coach.comment')}
                value={comment}
                multiline={true}
                rows={4}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setComment(e.target.value)}
            />
            <FormControlLabel
                control={
                    <Checkbox
                        onClick={() => setIsGroupedSession((prev: boolean) => !prev)}
                        checked={isGroupedSession}
                        color="default"
                    />
                }
                label={<Typography sx={{ fontSize: 14 }}>{t('content.events.coach.is_group')}</Typography>}
                sx={{ alignSelf: 'flex-start', mt: -2 }}
            />
            {hasNoDriver ? (
                <Typography color="error" fontSize={12}>
                    {t('content.events.coach.no_driver')}
                </Typography>
            ) : null}
            <Box textAlign="center">
                <Button
                    id="save-btn"
                    data-testid="save-btn"
                    variant="contained"
                    size="small"
                    disabled={hasNoDriver}
                    onClick={() => props.onSave(STATUS.SAVED, comment, isGroupedSession)}
                >
                    {t('content.coach.save')}
                </Button>
                {props.children}
            </Box>
        </Box>
    );
};

export default NewCoachingModal;
